import { FB_EVT_LOGGED_IN, FB_EVT_LOGGED_OUT } from '@/config/events-fb-pixel/events';

export const FBloggedIn = () => ({ eventName: FB_EVT_LOGGED_IN });

export const FBloggedOut = () => ({ eventName: FB_EVT_LOGGED_OUT });